import { API_ENDPOINTS } from "@/constants/api";
import { http } from "@/lib/http-client";
import { unwrapData } from "@/lib/api-response";
import type {
  CreateRoleInput,
  DashboardRoleItem,
  UpdateRoleInput,
} from "@/features/roles/types/role";

export const roleService = {
  async list(): Promise<DashboardRoleItem[]> {
    const response = await http.get(API_ENDPOINTS.ROLES.LIST);
    return unwrapData<DashboardRoleItem[]>(response);
  },

  async create(payload: CreateRoleInput): Promise<DashboardRoleItem> {
    const response = await http.post(API_ENDPOINTS.ROLES.CREATE, payload);
    return unwrapData<DashboardRoleItem>(response);
  },

  async update(code: string, payload: UpdateRoleInput): Promise<DashboardRoleItem> {
    const response = await http.put(API_ENDPOINTS.ROLES.DETAIL(code), payload);
    return unwrapData<DashboardRoleItem>(response);
  },

  async remove(code: string): Promise<void> {
    await http.delete(API_ENDPOINTS.ROLES.DETAIL(code));
  },
};
